import { c as _c } from "react/compiler-runtime";
import type { ItineraryCardSubheadingProps } from './ItineraryCard.types';
import styles from './ItineraryCardSubheading.module.css';
export function ItineraryCardSubheading(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className={styles.subheading}>{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}